import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { concat } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  // language
  language$ = new BehaviorSubject<string>('en');  

  // inGame
  inGameMode$ = new BehaviorSubject<boolean>(false);

  // reload 
  reload$ = new Subject<void>();

  constructor() { }

  start(authServce: any): Promise<boolean>  {
    return new Promise((resolve, reject) => {

      //authServce.isLoggedIn = true;

      // get all needed data before ready to use
      let startupData = [
        
      ]

      concat(...startupData)
        .subscribe({
          next: () => {},
          complete: () => resolve(true)
        });

    });

  }
}
